import { z } from "zod";

export const ENPS_BANDS = ["needs-work", "neutral", "good", "excellent"] as const;
export const EnpsBandSchema = z.enum(ENPS_BANDS);
export type EnpsBand = z.infer<typeof EnpsBandSchema>;

export function rateEnpsBand(score: number | null | undefined): EnpsBand | null {
    if (score === null || score === undefined) {
        return null;
    }
    if (score <= -30) {
        return "needs-work";
    }
    if (score <= 0) {
        return "neutral";
    }
    if (score <= 30) {
        return "good";
    }

    return "excellent";
}

export const EngagementEnpsHistoryPointSchema = z.object({
    date: z.string(),
    teamScore: z.number().nullable(),
    companyScore: z.number().nullable(),
    promotersCount: z.number().nullable(),
    passivesCount: z.number().nullable(),
    detractorsCount: z.number().nullable()
});
export type EngagementEnpsHistoryPoint = z.infer<typeof EngagementEnpsHistoryPointSchema>;
